export default __webpack_public_path__ + "static/media/Srinivasa Thangamaalihai.b9bec357.jpg";